import http from "./http";

function getLogoList(data) {
  return http.post(`dynamic_data`, data);
}
function addLogo(data) {
  return http.post(`dynamicLogoUpload`, data);
}
function updateLogo(data) {
  return http.post(`update_dynamicLogo`, data);
}

const LogoService = {
  getLogoList,
  addLogo,
  updateLogo,
};

export default LogoService;
